import { c as _c } from "react/compiler-runtime";
import type { AmlHit } from '@onefootprint/request-types/dashboard';
import HitItemRow from './components/hit-item-row';
type HitItemProps = {
  hit: AmlHit;
};
const HitItem = t0 => {
  const $ = _c(8);
  const {
    hit
  } = t0;
  let flattenedHit;
  let t1;
  if ($[0] !== hit) {
    const flattenHit = () => {
      const {
        name,
        matchTypes,
        fields,
        media
      } = hit;
      const sortedHit = [];
      if (name) {
        sortedHit.push({
          key: "name",
          value: name
        });
      }
      if (matchTypes) {
        sortedHit.push({
          key: "matchTypes",
          value: matchTypes
        });
      }
      if (fields && typeof fields === "object") {
        const sortedFields = Object.keys(fields).sort();
        sortedFields.forEach(key => {
          if (fields[key]) {
            sortedHit.push({
              key,
              value: fields[key]
            });
          }
        });
      }
      if (media?.length) {
        sortedHit.push({
          key: "relevantMedia",
          value: media
        });
      }
      return sortedHit;
    };
    flattenedHit = flattenHit();
    t1 = JSON.stringify(flattenedHit);
    $[0] = hit;
    $[1] = flattenedHit;
    $[2] = t1;
  } else {
    flattenedHit = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== flattenedHit) {
    t2 = flattenedHit.map(_temp);
    $[3] = flattenedHit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <li key={t1} className="flex flex-col transition-colors duration-200">{t2}</li>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default HitItem;
function _temp(t0) {
  const {
    key: key_0,
    value
  } = t0;
  return <HitItemRow key={key_0} fieldName={key_0} fieldValue={value} />;
}